import { render, staticRenderFns } from "./contentdetails.vue?vue&type=template&id=1911565f&"
import script from "./contentdetails.vue?vue&type=script&lang=js&"
export * from "./contentdetails.vue?vue&type=script&lang=js&"
import style0 from "./contentdetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports